import { getCurrentInstance as m } from "vue";
import { first as d } from "./utils.mjs";
const p = "bottom", v = ({ arg: e = "", modifiers: i = {}, value: o = { name: void 0, position: void 0 } }) => {
  const t = Object.keys(i), n = typeof o == "object" && o.name ? o.name : e, r = d(t) || o.position || p;
  return { name: n, position: r, value: o };
}, l = (e, i) => {
  const o = (n) => {
    console.log("onMouseEnter", n);
  }, t = (n) => {
    console.log("onMouseLeave", n);
  };
  e.addEventListener("mouseenter", o), e.addEventListener("mouseleave", t), e.$popoverRemoveHoverHandlers = () => {
    e.removeEventListener("mouseenter", o), e.removeEventListener("mouseleave", t);
  };
};
m();
const f = {
  async mounted(e, i, o) {
    console.log(e, i, o);
    const t = document.createElement("div");
    e.appendChild(t);
    let n;
    if (o.children) {
      const r = o.children;
      for (const c of r) {
        const s = c;
        s.key == "_IstPopover2" && (n = s, s.props && (s.props.visible = !0), s.el && (s.el = document.createElement("div")));
      }
    }
    n && (n.children || n.text), v(i), l(e);
  },
  unmounted: function(e) {
  }
};
export {
  f as tooltipDirective
};
